module.exports = __webpack_public_path__ + "img/dod_day12_image1.38472384.png";